module.exports = __webpack_public_path__ + "media/images/draps fournis-5c937e9433470499cc566132b0ab15d2.svg";